import React, { FC, memo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';

interface SendPriceRaiseNotificationProps {
  isOpened: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const SendPriceRaiseNotification: FC<SendPriceRaiseNotificationProps> = memo((props) => {
  const { isOpened, isLoading, onConfirm, onCancel } = props;
  const { t } = useAppTranslation(['contracts', 'common']);

  return (
    <ConfirmModal
      isOpened={isOpened}
      zIndex={1200}
      title={t('Send notification')}
      description={t('Are you sure you want to send the price raise notification?')}
      isLoading={isLoading}
      onOk={onConfirm}
      onCancel={onCancel}
    />
  );
});
